import React, { useEffect, useState } from "react";
import { api } from "../api/client";

interface EditRow {
  id: string;
  face: string;
  field_path: string;
  old_value: string | null;
  new_value: string;
  status: string;
  created_at: string;
  discord_username: string;
  avatar_url: string | null;
}

/** Historique des éditions d'une carte (texte original ou traduction précise) —
 * les données étaient déjà tracées (`card_text_edits`) mais jusqu'ici invisibles
 * depuis l'interface. */
export function EditHistory({ projectId, cardId, lang }: { projectId: string; cardId: string; lang: string | null }) {
  const [open, setOpen] = useState(false);
  const [edits, setEdits] = useState<EditRow[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api
      .listHistory(projectId, cardId, lang ?? undefined)
      .then((r) => setEdits(r.edits))
      .finally(() => setLoading(false));
  }, [open, projectId, cardId, lang]);

  return (
    <details className="edit-history" open={open} onToggle={(e) => setOpen((e.target as HTMLDetailsElement).open)}>
      <summary>Historique des modifications {lang ? `(${lang})` : "(original)"}</summary>
      {loading && <p>Chargement…</p>}
      {!loading && edits.length === 0 && <p className="edit-history__empty">Aucune modification enregistrée.</p>}
      <ul className="edit-history__list">
        {edits.map((e) => (
          <li key={e.id}>
            <div className="edit-history__meta">
              {e.avatar_url && <img src={e.avatar_url} alt="" />}
              <strong>{e.discord_username}</strong>
              <span className="edit-history__field">
                {e.face}.{e.field_path}
              </span>
              <span className="badge">{e.status}</span>
              <time>{new Date(e.created_at.replace(" ", "T") + "Z").toLocaleString()}</time>
            </div>
            <div className="edit-history__diff">
              {e.old_value != null && e.old_value !== "" && (
                <p className="edit-history__old">− {e.old_value}</p>
              )}
              <p className="edit-history__new">+ {e.new_value}</p>
            </div>
          </li>
        ))}
      </ul>
    </details>
  );
}
